export const CLIMATIQ_UK_GOV_WASTE_SOURCE = 'BEIS';

export function resolveClimatiqSourceForActivity(input: {
  scope?: 1 | 2 | 3;
  activityCategory?: string;
  scope3Category?: number;
  requestedSource?: string;
}): string | undefined {
  const normalizedCategory = input.activityCategory?.trim().toLowerCase();
  if (
    input.scope === 3 &&
    input.scope3Category === 5 &&
    normalizedCategory === 'waste_operations'
  ) {
    if (input.requestedSource) {
      return input.requestedSource;
    }
    return CLIMATIQ_UK_GOV_WASTE_SOURCE;
  }
  return input.requestedSource;
}
